import { hooks } from "./hookactions"
export let SYSShellbar = { hooks }
